import {MetaDataAttributeDto} from "./meta-data-attribute.dto";
import {MetaDataJoinDto} from "./meta-data-join.dto";

export class MetaDataGenericTypeDto {

    public typeId: number;
    public typeName: string;

    public attributes: MetaDataAttributeDto[];
    public joins: MetaDataJoinDto[];

}